import { Configuration } from '../configuration';
import { HttpClient } from '../http/HttpClient';
import {
    IUpdateGameProgressRequest,
    IUpdateUserGameResponse,
} from '../types/userGame';

export class UserGame {
    private httpClient: HttpClient;

    constructor(configuration: Configuration) {
        this.httpClient = new HttpClient(configuration);
    }

    public async updateProgress(
        userId: string,
        gameId: string,
        body: IUpdateGameProgressRequest,
    ): Promise<IUpdateUserGameResponse> {
        return await this.httpClient.put<IUpdateUserGameResponse>(
            `/user-games/${userId}/games/${gameId}/progress`,
            body,
        );
    }

    public async getById(
        userId: string,
        gameId: string,
        guestId?: string,
    ): Promise<IUpdateUserGameResponse> {
        return await this.httpClient.get<IUpdateUserGameResponse>(
            `/user-games/${userId}/games/${gameId}`,
            undefined,
            guestId ? { headers: { 'x-anonymous-id': guestId } } : undefined,
        );
    }
}
